var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIntegrationsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 19.5H2C1.45 19.5 0.979167 19.3042 0.5875 18.9125C0.195833 18.5208 0 18.05 0 17.5V13.7C0.8 13.7 1.5 13.4458 2.1 12.9375C2.7 12.4292 3 11.7833 3 11C3 10.2167 2.7 9.57083 2.1 9.0625C1.5 8.55417 0.8 8.3 0 8.3V4.5C0 3.95 0.195833 3.47917 0.5875 3.0875C0.979167 2.69583 1.45 2.5 2 2.5H6C6 1.8 6.24167 1.20833 6.725 0.725C7.20833 0.241667 7.8 0 8.5 0C9.2 0 9.79167 0.241667 10.275 0.725C10.7583 1.20833 11 1.8 11 2.5H15C15.55 2.5 16.0208 2.69583 16.4125 3.0875C16.8042 3.47917 17 3.95 17 4.5V8.5C17.7 8.5 18.2917 8.74167 18.775 9.225C19.2583 9.70833 19.5 10.3 19.5 11C19.5 11.7 19.2583 12.2917 18.775 12.775C18.2917 13.2583 17.7 13.5 17 13.5V17.5C17 18.05 16.8042 18.5208 16.4125 18.9125C16.0208 19.3042 15.55 19.5 15 19.5H11.2C11.2 18.6667 10.9375 17.9583 10.4125 17.375C9.8875 16.7917 9.25 16.5 8.5 16.5C7.75 16.5 7.1125 16.7917 6.5875 17.375C6.0625 17.9583 5.8 18.6667 5.8 19.5Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegrationsActive);
export default __webpack_public_path__ + "static/media/icon-integrations-active.e4c6134707452fde6c3f8fce1ba08c8c.svg";
export { ForwardRef as ReactComponent };